import {SET_SELECTED_FOLDER} from 'constants/action-types.js';
import {SET_SELECTED_PRESET} from 'constants/action-types.js';
import {SET_HAS_CHANGES_TO_FOLDERS} from 'constants/action-types.js';
import {SET_FOLDER_DRAGGING} from 'constants/action-types.js';
import {SET_PRESET_DRAGGING} from 'constants/action-types.js';
import {SET_TRACK_PRESET_SAVING} from 'constants/action-types.js';
import {SET_GROUP_PRESETS_BY_PACKS} from 'constants/action-types.js';
import {SET_PRESET_SAVED} from 'constants/action-types.js';

var initialState = {
    groupByPacks: true,
    selectedFolder: undefined,
    folderDragging: undefined,
    presetDragging: undefined,
    selectedPreset: undefined,
    hasChangesToFolders: false,
    trackPresetSaving: undefined,
};

const presetsReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_PRESET_SAVED:
        return {
            ... state,
            presetSaved: action.payload
        };
    case SET_GROUP_PRESETS_BY_PACKS:
        return {
            ... state,
            groupByPacks: action.payload
        };
    case SET_SELECTED_FOLDER:
        return {
            ...state,
            selectedPreset: undefined,
            selectedFolder: action.payload
        };
    case SET_SELECTED_PRESET:
        return {
            ...state,
            selectedFolder: undefined,
            selectedPreset: action.payload
        };
    case SET_HAS_CHANGES_TO_FOLDERS:
        return {
            ...state,
            hasChangesToFolders: action.payload
        };
    case SET_FOLDER_DRAGGING:
        return {
            ...state,
            folderDragging: action.payload
        };
    case SET_PRESET_DRAGGING:
        return {
            ...state,
            presetDragging: action.payload
        };
    case SET_TRACK_PRESET_SAVING:
        return {
            ... state,
            trackPresetSaving: action.payload
        };
    default:
        return state;
    }
};
export default presetsReducer;
